module.exports = __webpack_public_path__ + "assets/img/gift-other-87bc7866.png";